<template>
  <div class="dashboard-infos__location infos-location">
    <div class="infos-location__map">
      <GoogleMap
        :latitude="address.latitude"
        :longitude="address.longitude"
        :height="160"
        :zoom="14"
        :is-static="true"
        with-marker
      />
    </div>
    <p class="infos-location__address">
      {{ address.get_formatted_name }}
    </p>
  </div>
</template>

<script setup>
import GoogleMap from '@components-molecules/GoogleMap.vue';

defineProps({
  address: {
    type: Object,
    required: true,
  },
});
</script>
